var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJewelry2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_jewelry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jewelry_x5F_2_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCE4B0",
    d: "M368.1,507.4c-2.9,0-5.3-2.4-5.3-5.3s2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3S371,507.4,368.1,507.4L368.1,507.4 z M368.1,497.8c-2.3,0-4.3,1.9-4.3,4.3c0,2.3,1.9,4.3,4.3,4.3c2.3,0,4.3-1.9,4.3-4.3C372.3,499.7,370.4,497.8,368.1,497.8 L368.1,497.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M444.4,454.1c-0.8,0-1.5,0.7-1.5,1.5c0,0.2,0,0.4,0.1,0.5c-4.3,3.7-10.2,8.2-17,13c-0.3-0.5-0.8-0.8-1.4-0.8 c-1,0-1.7,0.8-1.7,1.7c0,0.4,0.1,0.7,0.3,1c-6.1,4.1-12.8,8.4-19.7,12.3c-0.3-0.4-0.8-0.7-1.4-0.7c-1,0-1.7,0.8-1.7,1.7 c0,0.2,0,0.4,0.1,0.6c-7.4,4.1-14.9,7.8-22,10.7c-0.3-0.4-0.8-0.7-1.4-0.7c-1,0-1.7,0.8-1.7,1.7c0,0.1,0,0.1,0,0.2 c-1.2,0.5-2.5,0.9-3.7,1.3c0.2,0.2,0.5,0.5,0.7,0.8c1.1-0.4,2.2-0.8,3.3-1.2c0.3,0.4,0.8,0.7,1.4,0.7c1,0,1.7-0.8,1.7-1.7v-0.1 c7.2-2.9,14.8-6.7,22.3-10.8c0.3,0.2,0.6,0.3,1,0.3c1,0,1.7-0.8,1.7-1.7c0-0.1,0-0.1,0-0.1c7.1-4,13.9-8.4,20.1-12.6 c0.2,0.1,0.4,0.1,0.6,0.1c1,0,1.7-0.8,1.7-1.7l0,0c7-4.8,12.9-9.4,17.3-13.2c0.2,0.1,0.5,0.2,0.8,0.2c0.8,0,1.5-0.7,1.5-1.5 S445.2,454.1,444.4,454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE5B0",
    d: "M368.1,522.7c-0.6,0.9-1.5,1.9-2.1,2.8c-0.9,1.1-1.5,1.9-2,0.5c-0.4-1.2-2.4-6.2-0.9-7 c0.8-0.4,3.7,0.3,4.5,0.6C369.2,520.1,369.1,521.6,368.1,522.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.7,498.8c-2.4-0.8-4.8-1.5-7.3-2.3c-6.5-2-13.3-4.2-20.4-6.7c0-0.1,0-0.1,0-0.2c0-1-0.8-1.7-1.7-1.7 c-0.6,0-1.2,0.3-1.5,0.8c-8.6-3.1-17.5-6.7-26.3-11.1c0-0.1,0.1-0.3,0.1-0.4c0-1-0.8-1.7-1.7-1.7c-0.5,0-1,0.2-1.3,0.6 c-8.2-4.3-16.4-9.3-24.2-15.3c0.1-0.2,0.1-0.4,0.1-0.6c0-1-0.8-1.7-1.7-1.7c-0.4,0-0.7,0.1-1,0.3c-1.3-1.1-2.7-2.2-4-3.4 c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7c1.3,1.2,2.7,2.3,4,3.4c-0.1,0.2-0.2,0.5-0.2,0.7c0,1,0.8,1.7,1.7,1.7 c0.4,0,0.8-0.1,1.1-0.4c7.8,6.1,16,11.1,24.3,15.4c0,0.1,0,0.2,0,0.2c0,1,0.8,1.7,1.7,1.7c0.5,0,0.9-0.2,1.2-0.5 c8.9,4.4,17.9,8.1,26.6,11.2c0,1,0.8,1.7,1.7,1.7c0.5,0,1-0.2,1.3-0.6c7.1,2.5,14,4.7,20.5,6.7c2.5,0.8,4.9,1.6,7.2,2.3 C363.3,499.3,363.5,499,363.7,498.8C363.8,498.8,363.7,498.8,363.7,498.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCE5B0",
    d: "M371.2,506.3c-0.3,0.2-0.6,0.4-0.9,0.6c1.8,3.8,2.8,6.1,2,9.2s-3.6,5.3-6.6,5.1s-6.5-2.2-7-5.3 c-0.6-3.6,2.5-7.5,5.7-10c-0.3-0.2-0.5-0.5-0.7-0.8c-1.8,1.4-6.9,6-6,11c0.6,3.6,4.6,6,8,6.2c0.1,0,0.3,0,0.4,0 c3.4,0,6.4-2.4,7.3-5.9C374.2,512.9,373,510.2,371.2,506.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDE4B0",
    d: "M373.2,543.5c-1.9-1.5-3.4-3.9-4.2-6.2c-0.2,1,0,5-1.5,4.9c-1.4-0.1-2-3.7-2.5-4.7 c-0.1,1.1,0.4,3.8-1.1,3.9c-1.5,0.1-2.4-1.7-3.1-2.6c-0.4,1.2-0.6,2.7-0.9,4c-0.2,0.8-0.4,2.2-1.5,2c-0.4-0.1-0.7-0.2-0.9-0.5 c1.4,18.2-1.9,46-9.4,68c-0.9,4.4,1.1,2.9,2.3,1.9c15.5-14.2,25.7-38.6,23.9-70.5C374,544,373.6,543.8,373.2,543.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCE5B0",
    d: "M364.7,531.7c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S366.5,531.7,364.7,531.7 L364.7,531.7z M364.7,526.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2C366.9,527.2,365.9,526.2,364.7,526.2L364.7,526.2 z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M375.5,537.6c0-2.2-0.5-4.2-1.2-6.2c-1-2.7-0.9-2.1-3.5-2c-2.1,0.1-6.1,0.7-8.1,0.9h-0.2 c-1.9,0.3-4.4,0.4-6.1,1.1c-1.6,0.7-1.1,3.1-0.9,5.4c0.1,2,0.5,4,1.1,5.9c0.2,0.8,0.8,2,1.8,2.1c1.1,0.2,1.3-1.2,1.5-2 c0.3-1.2,0.5-2.8,0.9-4c0.8,0.9,1.7,2.7,3.1,2.6c1.5-0.1,1-2.8,1.1-3.9c0.5,1.1,1.1,4.7,2.5,4.7c1.5,0.1,1.3-3.9,1.5-4.9 c0.8,2.3,2.3,4.7,4.2,6.2c0.6,0.5,1.4,0.6,1.9-0.8C375.6,541.4,375.5,539,375.5,537.6z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00BF00",
    strokeWidth: 0.1064,
    x1: 369.3,
    y1: 539.9,
    x2: 369.6,
    y2: 539.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DE9D71",
    d: "M367.5,542.3c0.7,0,1-0.9,1.2-2l-1.9,1.6C367,542.1,367.3,542.2,367.5,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE9D71",
    d: "M370.8,529.4c-0.2,0-0.5,0-0.8,0l-14.1,9.9c0.1,0.7,0.3,1.4,0.4,2.1l16.9-12 C372.8,529.2,372.2,529.3,370.8,529.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE9D71",
    d: "M375.2,534.8l-5.4,4.6c0.2,0.4,0.5,0.8,0.7,1.2l4.8-4.1C375.4,535.9,375.3,535.3,375.2,534.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF2D8",
    d: "M357.8,550.7c0.2,11.4-1,25.2-3.7,38.8C365.2,581.1,366.7,561.5,357.8,550.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF2D8",
    d: "M368.7,586.3c3.3-8.9,5.3-19,5.8-30.3C366,561.8,365.1,578,368.7,586.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1BA88",
    d: "M357.8,558.6c0,0.6,0,1.3-0.1,1.9c2.7,3.7,2.1,11.5-1.4,16.1c-0.2,1.4-0.4,2.8-0.6,4.2 C361.3,575.1,363.1,564.8,357.8,558.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF2D8",
    d: "M349.1,609.6c-0.3,0.9-0.6,1.9-0.9,2.8c-0.9,4.4,1.1,2.9,2.3,1.9c6.3-5.8,11.8-13.3,15.9-22.3 C361,593.8,353.2,601.1,349.1,609.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1BA88",
    d: "M350.8,603.9c-0.5,1.9-1.1,3.8-1.7,5.7c4.1-8.4,11.9-15.7,17.3-17.6c0.4-0.8,0.7-1.6,1-2.3 C360.3,591.9,354.4,597.4,350.8,603.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1BA88",
    d: "M374.6,548.9c0-0.9,0-1.7-0.1-2.6c-8.2,10.6-12,26.5-5.3,38.6c0.3-0.9,0.6-1.8,0.9-2.7 C365.4,572.6,367.8,557.9,374.6,548.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry2);
export default __webpack_public_path__ + "static/media/jewelry_2.4eda1f72fcbd55be5dc10a118c28fa59.svg";
export { ForwardRef as ReactComponent };